module.exports = __webpack_public_path__ + "img/entityEle.e5e21e23.svg";